import React from 'react'
import { AppButton, AppDialogBody, AppDialogFooter } from '@easyllama/ui-components'
import AssignLlama from '~/assets/assign-llama.svg'

export default function ChangePlanSuccessStep({ onClose }) {
  return (
    <>
    <AppDialogBody className='text-center flex flex-col items-center'>
      <h2 className='text-2xl pb-4 font-normal text-llama-grey-7 font-[Recoleta]'>Congratulations!</h2>
      <div className='w-36 h-36 rounded-full flex items-center justify-center overflow-hidden shrink-0 pb-4'>
        <img src={AssignLlama} alt='celebration llama' className='w-full h-full object-contain' />
      </div>
      <p className='text-base font-bold text-llama-grey-7 pb-4 text-left'>
        Your plan has been updated
      </p>
      <p className='text-sm text-llama-grey-5 leading-relaxed pb-4 text-left'>
        Changes will apply within a couple of minutes.
      </p>
    </AppDialogBody>
    <AppDialogFooter>
      <AppButton className='w-full' onClick={onClose}>
        Awesome!
      </AppButton>
    </AppDialogFooter>
    </>
  )
}
